import styled from 'styled-components';

const ProductsMenuContainer = styled.div`
  .simple-nav-col {
    min-width: 184px;
  }

  .simple-nav-item {
    align-items: center;
    display: flex;
    flex: 1;
    padding: 10px;
    margin-bottom: 5px;
    width: calc(100% + 10px);
    margin-left: -10px;

    .styles-container {
      width: max-content;
    }

    h6 {
      margin: 0;
      position: relative;
      font-size: 14px;
      font-weight: 500;
    }

    .beta {
      color: #3f2b94;
      background: #f1edfe;
      border-radius: 4px;
      font-weight: 500;
      margin-left: 8px;
      font-size: 13px;
      padding: 0px 6px;
      position: absolute;
      top: -4px;
      height: 23px;
      padding-top: 3px;
      right: -47px;
    }

    &:last-child {
      margin-bottom: 0;
    }
  }

  img {
    width: 28px;
    margin-right: 15px;
    image-rendering: unset;
  }

  a {
    color: var(--black);
    margin-top: 3px;
  }

  .group-title {
    color: var(--titan-blue-3);
    font-size: 14px;
    font-weight: 800;
    line-height: 24px;

    span {
      padding: 3px 7px 1px;
      border-radius: 4px;
      background: var(--titan-blue-3);
      color: var(--white);
      margin-left: 3px;
    }
  }
`;

export { ProductsMenuContainer };
